import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import artifactProductionStatuses from "astrid-firestore/src/api/artifacts/constants/artifactProductionStatuses";
import isArtifactContentTypeAccepted from "astrid-firestore/src/api/artifacts/isArtifactContentTypeAccepted";
import softDeleteDocument from "astrid-firestore/src/api/documents/softDeleteDocument";

import getArtifactProductionStatus from "../../../../artifacts/utils/getArtifactProductionStatus";
import { useProfile } from "../../../../authentication/state/profile";
import useHasRight from "../../../../authorization/hooks/useHasRight";

export default function useProductionArtifactDropdownMenuOptions({ canDeliver, articles, production, moveArtifact }) {
	const { t } = useTranslation();

	const user = useProfile();
	const hasRight = useHasRight();

	return ({ artifact, article }) => {
		const status = getArtifactProductionStatus({ artifact });

		return [
			{
				text: t("view", "View"),
				linkTo: `/production/${production.id}/artifacts/${artifact.id}`,
			},
			...articles
				.filter(
					(a) =>
						canDeliver &&
						a.id !== article?.id &&
						isArtifactContentTypeAccepted({ article: a, artifact }) &&
						!production?.articles?.[a.id]?.artifactIds?.length,
				)
				.map((article) => ({
					text: t("moveToArticle", "Move to {{article}}", { article: `${article.name} (${article.isbn})` }),
					action: () => {
						return moveArtifact(artifact.id, article.id, 0);
					},
				})),
			{
				text: t("moveToParking", "Move to parking"),
				hidden: !article || !canDeliver,
				disabled: status === artifactProductionStatuses.DELIVERED,
				action: () => {
					return moveArtifact(artifact.id, "unassigned");
				},
			},
			{
				text: t("delete", "Delete"),
				hidden: !hasRight("artifacts.delete"),
				disabled: status === artifactProductionStatuses.DELIVERED,
				confirmText: t("deleteArtifactConfirmation", "Are you sure you want to delete this artifact?"),
				action: () => {
					return softDeleteDocument(firebase, artifact, user);
				},
			},
		];
	};
}
